import {Client} from "@stomp/stompjs";

export const mqttSender = (publishModel, userId = "hilight") => {
    const client = new Client({
        brokerURL: `ws://${window.location.hostname}:15674/ws`,
        connectHeaders: {
            login: "guest",
            passcode: "guest",
            'client-id': 'hilight-view-'+ userId
        },
        reconnectDelay: 4000
    });

    client.onConnect = (frame) => {
        client.publish(publishModel);
        client.deactivate();
    };

    client.onStompError = (frame) => {
        console.log('Broker reported error: ' + frame.headers['message']);
        console.log('Additional details: ' + frame.body);
    };

    client.activate();
};

export const sendStartCommand = (singleDevice) => {
    return {
        destination: '/exchange/monitor_general',
        body: JSON.stringify({
            command: "start",
            networkDeviceId: singleDevice.id,
            label: singleDevice.label,
        })
    };
};

export const sendStopCommand = (singleDevice) => {
    return {
        destination: '/exchange/monitor_general',
        body: JSON.stringify({
            command: "stop",
            networkDeviceId: singleDevice.id,
            label: singleDevice.label,
        })
    };
};
